const getters = {
  allEmployeeTags: (state) => state.allEmployeeTags || [],
};

export default getters;
